import React from 'react';
import { getMyTechAvailability, updateMyTechAvailability } from '../lib/api';
import AvailabilityPage from '../components/AvailabilityPage';

export default function TechAvailabilityPage() {
  return (
    <AvailabilityPage
      getAvailability={getMyTechAvailability}
      updateAvailability={updateMyTechAvailability}
      backTo="/tech/me"
    />
  );
}
